// Mirrors the ``max_length`` of the matching ``User`` fields in the backend: the
// inputs are capped at them so a value the API would reject cannot be typed at all.
export const USER_NAME_MAX_LENGTH = 150;
